/**
 * A function acting like a class
 * Called when a promise is cancelled. The cancelled promise will be rejected with CanceledPromiseError reason.
 * It allows us to differentiate if promise is rejected because of cancellation or for any other reason.
 * https://stackoverflow.com/questions/41927040/generate-customized-exceptions-in-react
 * Idéalement il faudrait une classe qui hérite de 'Error'.
 * Pour cela il faut activer le plugin babel babel-plugin-transform-builtin-extend.
 * https://www.npmjs.com/package/babel-plugin-transform-builtin-extend
 */
export function CanceledPromiseError() {
   this.message = "Promise canceled";
   this.name = "CanceledPromiseError";
}

/**
 * Wraps a promise in an object to allow cancellation.
 * A cancelled promise will always be rejected
 * https://medium.com/@rajeshnaroth/writing-a-react-hook-to-cancel-promises-when-a-component-unmounts-526efabf251f
 * @param {any} promise The promise to wrap
 */
export function makeCancelable(promise) {
   let isCanceled = false;

   const wrappedPromise =
      new Promise((resolve, reject) => {
         promise
            .then(
               val => (isCanceled
                  ? reject(new CanceledPromiseError())
                  : resolve(val))
            )
            .catch(
               error => (isCanceled
                  ? reject(new CanceledPromiseError())
                  : reject(error))
            );
      });

   return {
      promise: wrappedPromise,
      cancel() {
         isCanceled = true;
      },
   };
}

